export default "./dist/stdassets/images/icons/select-clear.png";